export const BUY_GAS = "BUY_GAS";
export const SELL_GAS = "SELL_GAS";
export const GET_GAS = "GET_GAS";
